import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _this = this;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Base64 } from "js-base64";
import { each } from "lodash";
import { parse as parseQs, stringify as stringifyQs } from "query-string";
import { GatewayTypesEnum } from "@globalTypes/globalTypes";
import { paymentMessages } from "@temp/intl";
import { OrderDirection, ProductOrderField } from "../../gqlTypes/globalTypes";
export var slugify = function slugify(text) {
  return text.toString() // Convert text to string (just in case)
  .toLowerCase() // Convert to lowercase
  .trim() // Remove whitespace from both ends of a string
  .normalize("NFD") // Normalize the text to NFD form
  .replace(/[\u0300-\u036f]/g, "") // Remove accents and diacritics
  .replace(/&/g, "-and-") // Replace & with 'and'
  .replace(/[^a-z0-9 -]/g, "") // Remove non-alphanumeric characters
  .replace(/\s+/g, "-") // Replace spaces with hyphens
  .replace(/[^\w\-]+/g, "") // Remove all non-word chars
  .replace(/-+/g, "-");
}; // Replace multiple hyphens with a single hyphen

export var getDBIdFromGraphqlId = function getDBIdFromGraphqlId(graphqlId, schema) {
  // This is temporary solution, we will use slugs in the future
  var rawId = Base64.decode(graphqlId);
  var regexp = /(\w+):(\d+)/;
  var arr = regexp.exec(rawId);

  if (schema && schema !== arr[1]) {
    throw new Error("Schema is not correct");
  }

  return parseInt(arr[2], 10);
};
export var getGraphqlIdFromDBId = function getGraphqlIdFromDBId(id, schema) {
  return (// This is temporary solution, we will use slugs in the future
    Base64.encode("".concat(schema, ":").concat(id))
  );
};
export var priceToString = function priceToString(price, locale) {
  var amount = price.amount;

  if (locale) {
    return amount.toLocaleString(locale, {
      currency: price.currency,
      style: "currency"
    });
  }

  return "".concat(price.currency, " ").concat(amount.toFixed(2));
};
export var generateProductVariantUrl = function generateProductVariantUrl(id, name, subCategoryId) {
  return "/product/".concat(slugify(name), "/").concat(getDBIdFromGraphqlId(id, "ProductVariant"), "/").concat(getDBIdFromGraphqlId(subCategoryId, "Category"), "/");
};
export var generateProductUrl = function generateProductUrl(id, name, categoryId) {
  return "/product/".concat(slugify(name), "/").concat(getDBIdFromGraphqlId(id, "Product"), "/").concat(getDBIdFromGraphqlId(categoryId, "Category"), "/");
};
export var generateCategoryUrl = function generateCategoryUrl(id, name) {
  return "/category/".concat(slugify(name), "/").concat(getDBIdFromGraphqlId(id, "Category"), "/");
};
export var generateCategoryProductUrl = function generateCategoryProductUrl(id, name) {
  return "/subcategory/".concat(slugify(name), "/").concat(getDBIdFromGraphqlId(id, "Category"), "/");
};
export var generateSaleCategoryProductUrl = function generateSaleCategoryProductUrl(id, name) {
  return "/sale/category/".concat(slugify(name), "/").concat(getDBIdFromGraphqlId(id, "Category"), "/");
};
export var generateCollectionUrl = function generateCollectionUrl(id, name) {
  return "/collection/".concat(slugify(name), "/").concat(getDBIdFromGraphqlId(id, "Collection"), "/");
};
export var generatePageUrl = function generatePageUrl(slug) {
  return "/page/".concat(slug, "/");
};
export var convertToAttributeScalar = function convertToAttributeScalar(attributes) {
  return Object.entries(attributes).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return value.map(function (attribute) {
      return {
        slug: key,
        value: attribute
      };
    });
  }).reduce(function (prev, curr) {
    return [].concat(_toConsumableArray(prev), _toConsumableArray(curr));
  }, []);
};
export var getAttributesFromQs = function getAttributesFromQs(qs) {
  return Object.keys(qs).filter(function (key) {
    return !["pageSize", "priceGte", "priceLte", "sortBy", "q"].includes(key);
  }).reduce(function (prev, curr) {
    prev[curr] = typeof qs[curr] === "string" ? [qs[curr]] : qs[curr];
    return prev;
  }, {});
};
export var getValueOrEmpty = function getValueOrEmpty(value) {
  return value === undefined || value === null ? "" : value;
};
export var convertSortByFromString = function convertSortByFromString(sortBy) {
  if (!sortBy) {
    return null;
  }

  var direction = sortBy.startsWith("-") ? OrderDirection.DESC : OrderDirection.ASC;
  var field;

  switch (sortBy.replace(/^-/, "")) {
    case "name":
      field = ProductOrderField.NAME;
      break;

    case "price":
      field = ProductOrderField.MINIMAL_PRICE;
      break;

    case "updated_at":
      field = ProductOrderField.DATE;
      break;

    default:
      return null;
  }

  return {
    field: field,
    direction: direction
  };
};
export var maybe = function maybe(exp, d) {
  try {
    var result = exp();
    return result === undefined ? d : result;
  } catch (_unused) {
    return d;
  }
};
export var parseQueryString = function parseQueryString(location) {
  var query = parseQs(window.location.search.substr(1));
  each(query, function (value, key) {
    if (Array.isArray(value)) {
      query = _objectSpread(_objectSpread({}, query), {}, _defineProperty({}, key, value[0]));
    }
  });
  return query;
};
export var updateQueryString = function updateQueryString(location, history) {
  var querystring = parseQueryString(location);
  return function (key, value) {
    if (value === "") {
      delete querystring[key];
    } else {
      querystring[key] = value || key;
    }

    history.replace("?".concat(stringifyQs(querystring)));
  };
};
export var findFormErrors = function findFormErrors(result) {
  if (result) {
    var data = Object.values(maybe(function () {
      return result.data;
    }));
    return data.reduce(function (prevVal, currVal) {
      var errors = currVal.errors || [];
      return [].concat(_toConsumableArray(prevVal), _toConsumableArray(errors));
    }, []);
  }

  return [];
};
export var removeEmptySpaces = function removeEmptySpaces(text) {
  return text.replace(/\s+/g, "");
};
export var debounce = function debounce(func, delay) {
  var debounceTimer;
  return function (e) {
    var context = _this;
    clearTimeout(debounceTimer);
    e.persist(); // Persist Event

    debounceTimer = setTimeout(function () {
      return func.apply(context, [e]);
    }, delay);
  };
}; // export const structureSubcategories =

export var comprimirImagen = function comprimirImagen(imagenComoArchivo, porcentajeCalidad) {
  return new Promise(function (resolve, reject) {
    var canvas = document.createElement("canvas");
    var imagen = new Image();

    imagen.onload = function () {
      canvas.width = imagen.width;
      canvas.height = imagen.height;
      canvas.getContext("2d").drawImage(imagen, 0, 0);
      canvas.toBlob(function (blob) {
        if (blob === null) {
          return reject(blob);
        }

        resolve(blob);
      }, "image/jpeg", porcentajeCalidad / 100);
    };

    imagen.src = URL.createObjectURL(imagenComoArchivo);
  });
};
export var handleChangeImage = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, setPhotoError, setImageBlob, nameImage) {
    var imagen, imagenName, blob;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            imagen = e.target.files[0];
            imagenName = imagen.name;
            _context.next = 4;
            return comprimirImagen(imagen, 18);

          case 4:
            blob = _context.sent;

            if (nameImage) {
              blob.name = nameImage;
            } else {
              blob.name = imagenName;
            }

            setImageBlob(blob); // const blobUrl = URL.createObjectURL(blob); -- How to get the url of the image

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleChangeImage(_x, _x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var removeScrollItems = function removeScrollItems() {
  localStorage.removeItem("scroll-home");
  localStorage.removeItem("scroll-categories");
  localStorage.removeItem("scroll-category");
  localStorage.removeItem("scroll-sale");
  localStorage.removeItem("scroll_order_list");
  localStorage.removeItem("scroll-product");
};
/**
 * Filter out the manual-transfer gateway from a list the customer can *pick*
 * (checkout payment selection, change-payment alert). The gateway must stay
 * available on read-only / delivery contexts (deliverer flow on
 * OrderDataDelivery), where it may already be the order's current gateway.
 */

export var filterSelectablePaymentGateways = function filterSelectablePaymentGateways(gateways) {
  if (!gateways) {
    return [];
  }

  return gateways.filter(function (gw) {
    return (gw === null || gw === void 0 ? void 0 : gw.id) !== GatewayTypesEnum.MANUAL_TRANSFER;
  });
};
export var paymentMethodOptions = function paymentMethodOptions(intl) {
  return [{
    id: GatewayTypesEnum.DATAPHONE,
    name: intl.formatMessage(paymentMessages.card)
  }, {
    id: GatewayTypesEnum.CASH,
    name: intl.formatMessage(paymentMessages.cash)
  }, {
    id: GatewayTypesEnum.NEQUI,
    name: intl.formatMessage(paymentMessages.nequi)
  }, {
    id: GatewayTypesEnum.ONLINE_CREDIBANCO,
    name: intl.formatMessage(paymentMessages.onlineCredibanco)
  }];
};